(function(root){'use strict';
// Canonical actuator roll views reviewed in the Boat Hatch CAD pilot.
// Keep every catalogue family explicit: 0 is a reviewed choice, never a fallback.
root.FGActuatorCADOrientationDefaults=Object.freeze({
 'linear-actuators':180,
 'adjustable-stroke-linear-actuators':180,
 'bullet-series-23-cal':0,
 'bullet-series-35-cal-linear-actuators':0,
 'bullet-series-36-cal-linear-actuators':0,
 'bullet-series-50-cal-linear-actuators':0,
 'bullet-series-mini-actuators':0,
 'c-series-actuators':180,
 'deluxe-rod-actuator':0,
 'f12-micro-linear-actuators':0,
 'feedback-rod-actuator':180,
 'industrial-heavy-duty-linear-actuators':0,
 'heavy-duty-linear-actuator-ip66':0,
 'heavy-duty':0,
 'heavy-duty-track-actuator':0,
 'high-speed-actuator':0,
 'industrial-actuators':0,
 'electric-column-lift':0,
 'micro-actuators':0,
 'micro-actuators-12v':0,
 'micro-utility-actuator':0,
 'mini-linear-actuator':0,
 'mini-track-actuator':0,
 'optical-sensor-actuators':180,
 'premium-high-force-linear-actuators':180,
 'premium-linear-actuators':180,
 'power-max-heavy-duty-actuators':0,
 'silent-micro-linear-actuator':0,
 'tubular-linear-actuator':0,
 'super-duty-actuators':180,
 'utility-linear-actuators':90
});
// Compatibility name used by the original Boat Hatch pilot and its QA harness.
root.FGCADHatchOrientationDefaults=root.FGActuatorCADOrientationDefaults;
})(window);
